<template>
  <b-overlay
  :show="loading"
  rounded="lg">
  <b-card title="Direct Sales">
    <b-row>
      <!-- Modal for showing Job Order Details When Clicking Approve-->
      <b-modal
        v-model="promptDetail"
        title="Mama Drum Confirmation"
        id="promptDetail"
        size="xl"
        ok-only
      >
        <b-row>
          <b-col cols="3">
            Job Order Number :
          </b-col>
          <b-col cols="9">
            {{ detailModal.orderNumber }}
          </b-col>
          <b-col cols="3">
            Type :
          </b-col>
          <b-col cols="9">
            {{ detailModal.props.type }}
          </b-col>
          <b-col cols="3">
            Created At:
          </b-col>
          <b-col cols="9">
            {{ new Date(detailModal.createdAt).toLocaleString() }}
          </b-col>
          <b-col cols="3">
            Updated At :
          </b-col>
          <b-col cols="9">
            {{ new Date(detailModal.updatedAt).toLocaleString() }}
          </b-col>
          <b-col cols="12" style="margin-top:10px">
            <div class="scrollable-table">
            <b-table
              :items="detailModal.item"
              :fields="items_detail_fields"
              responsive="sm"
              hover
              head-variant="dark"
              outlined
              small
              stacked="md"
            >
              <template #cell(no)="row">
                {{ row.index + 1 }}
              </template>
              <template #cell(lineItemDescription)="row">
                {{ row.item.pickList.lineItem + ' - ' + row.item.pickList.lineDescription }}
              </template>
            </b-table>
            </div>
            <b-row>
              <b-col cols="6">
                <b-button
                  variant="success"
                  size="sm"
                  block
                  class="float-right"
                  @click="approve()"
                  >Accept Mama Drum</b-button
                >
              </b-col>
              <b-col cols="6">
                <b-button
                  variant="danger"
                  size="sm"
                  block
                  class="float-left"
                  @click="
                    reject();
                    promptDetail = false;
                  "
                  >Reject Mama Drum</b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <template #modal-footer>
          <div class="w-100"></div>
        </template>
      </b-modal>
      <b-col cols="12">
        <b-row style="margin-bottom:15px;">
          <b-col cols="8" />
          <b-col cols="4">
            <div>
              <b-form-input
                v-model="search"
                @input="debounceSearch"
                type="search"
                placeholder="Type to Search"
                style="float: right;"
              />
            </div>
          </b-col>
        </b-row>
        <b-row style="margin-bottom:10px" class="show-on-mobile">
          <b-col>
            <b-form-checkbox
              v-model="stackedStatus"
              value="md"
              unchecked-value="false"
            >
              Stacked Table
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="scrollable-table">
              <b-table
                :filter="search"
                responsive
                small
                show-empty
                head-variant="dark"
                outlined
                :items="jobOrders"
                :fields="headers"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :stacked="stackedStatus"
              >
                <template #cell(soNumber)="row">
                  {{ formatJoin(row.item.item.map((x) => x.pickList.orderNumber)) }}
                </template>
                <template #cell(picklistNumber)="row">
                  {{ formatJoin(row.item.item.map((x) => x.pickList.picklistNo + '_' + x.pickList.picklistLine)) }}
                </template>
                <template #cell(lineDescription)="row">
                  {{ formatJoin(row.item.item.map((x) => x.pickList.lineDescription)) }}
                </template>
                <template #cell(quantity)="row">
                  {{ formatJoin(row.item.item.map((x) => x.pickList.quantity)) }}
                </template>
                <template #cell(unit)="row">
                  {{ formatJoin(row.item.item.map((x) => x.pickList.unit)) }}
                </template>
                <template #cell(fromBatch)="row">
                  {{ formatJoin(row.item.item.map((x) => x.pickList.fromBatch)) }}
                </template>
                <template #cell(toBatch)="row">
                  {{ formatJoin(row.item.item.map((x) => x.pickList.toBatch)) }}
                </template>
                <template #cell(cuttingNumber)="row">
                  {{ formatJoin(row.item.item.map((x) => x.pickList.cuttingNumber)) }}
                </template>
                <template #cell(cableLength)="row">
                  {{ formatJoin(row.item.item.map((x) => x.pickList.cableLengthInfo)) }}

                </template>
                <template #cell(cableWeight)="row">
                  {{ formatJoin(row.item.item.map((x) => x.pickList.cableWeight)) }}
                </template>
                <template #cell(remark)="row">
                  {{ formatJoin(row.item.item.map((x) => x.pickList.remark)) }}
                </template>
                <template v-slot:cell(actions)="row">
                  <b-dropdown variant="success" size="sm" text="Menu" no-caret>
                    <template #button-content>
                      <feather-icon size="1x" icon="MenuIcon" />
                    </template>
                    <b-dropdown-item 
                      v-if="
                      row.item.props.status == 35 ||
                      row.item.status == 'Finished'
                    ">
                      <b-button
                        variant="success"
                        class="mr-1"
                        :to="{
                          name: 'view-direct-sales',
                          params: { id: row.item.id },
                        }"
                        size="sm"
                      >
                        <feather-icon size="1x" icon="EyeIcon"></feather-icon>
                      </b-button>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="permission.edit && row.item.props.status == 25 && row.item.props.MDE != undefined">
                      <b-button
                        variant="success"
                        size="sm"
                        style="margin-right:10px"
                        @click="
                          openDetail(row.item);
                        "
                        >Mama Drum Confirmation</b-button
                      >
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4" class="pt-1">
            <b-form-group
              label="Data Per Page"
              label-for="per-page-select"
              label-cols-md="0"
              label-align-sm="left"
              label-size="md"
              class="mb-0"
            >
              <v-select
                class="select-sm"
                :clearable="false"
                id="per-page-select"
                v-model="perPage"
                :options="pageOptions"
                @input="queryJobOrder()"
              ></v-select>
            </b-form-group>
          </b-col>
          <b-col class="pt-1">
            <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              @change="onPageChange"
              :total-rows="totalRows"
              first-number
              last-number
              class="float-right"
              aria-controls="user-table"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</b-overlay>
</template>

<script>
import {
  userAccess,
} from "@/utils/utils.js";

import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      loading: true,
      stackedStatus: "md",
      showSpinner: false,
      headers: [
        { key: "soNumber", label: "SO Number"},
        { key: "picklistNumber", label: "Picklist Number"},
        { key: "lineDescription", label: "Line Item Description"},
        { key: "quantity", label: "Quantity"},
        { key: "unit", label: "Unit"},
        { key: "fromBatch", label: "From Batch"},
        { key: "toBatch", label: "To Batch"},
        { key: "cuttingNumber", label: "Cutting Number"},
        { key: "cableLength", label: "Cable Length"},
        { key: "cableWeight", label: "Cable Weight"},
        { key: "remark", label: "Remark"},
        { key: "props.type", label: "Type", filterable: true, sortable: true },
        { key: "props.status", label: "Status", filterable: true, sortable: true },
        { key: "actions", label: "Actions" },
      ],
      items_detail_fields: [
        {key: "pickList.orderNumber", label: "SO Number"},
        {key: "orderNumber", label: "Picklist Number"},
        {key: "lineItemDescription", label: "Line Item Description"},
        {key: "pickList.quantity", label: "Quantity"},
        {key: "pickList.unit", label: "Unit"},
        {key: "pickList.fromBatch", label: "From Batch"},
        {key: "pickList.toBatch", label: "To Batch"},
        {key: "pickList.cuttingNumber", label: "Cutting Number"},
        {key: "pickList.cableLengthInfo", label: "Cable Length"},
        {key: "pickList.cableWeight", label: "Cable Weight"},
        {key: "pickList.remark", label: "Remark"},
      ],
      search: null,
      pageOptions: [5, 10, 20, 100],
      sortBy: "",
      sortDesc: false,
      currentPage: 1,
      perPage: 5,
      totalRows: 1,
      promptDetail: false,
      //for show jobdetails
      detailModal: {
        id: '',
        orderNumber: "",
        props: {
          type: "",
        },
        createdAt: "",
        updatedAt: "",
        item: [],
      },
    };
  },
  mounted() {
    this.queryJobOrder();
    // Saving Menu Setting on localstorage session so it still same even after reloading the page
    if (this.$session.has("perPageDirectSales")) {
      this.perPage = this.$session.get("perPageDirectSales");
    }
    if (this.$session.has("sortByDirectSales")) {
      this.sortBy = this.$session.get("sortByDirectSales");
    }
    if (this.$session.has("sortDescDirectSales")) {
      this.sortDesc = this.$session.get("sortDescDirectSales");
    }
  },
  watch: {
    perPage(perPageNew) {
      this.$session.set("perPageDirectSales", perPageNew);
    },
    sortBy(sortByNew) {
      this.$session.set("sortByDirectSales", sortByNew);
    },
    sortDesc(sortDescNew) {
      this.$session.set("sortDescDirectSales", sortDescNew);
    },
  },
  methods: {
    ...mapActions({
      getJobOrders: "joborder/getDirectSales",
    }),
    formatJoin(data) {
      if (!Array.isArray(data) || data.length === 0) {
        return ''
      }
      // Remove empty strings and undefined, then deduplicate
      const filtered = Array.from(new Set(data.filter(x => x !== '' && x !== undefined && x !== ' ')))
      return filtered.join(', ')
    },

    processMetadata(metadata) {
      let { totalData } = metadata;
      this.totalRows = totalData;
    },

    queryJobOrder(){
      this.loading = true
      this.getJobOrders({
        entry : this.perPage,
        page : this.currentPage,
      }).then((data) => {
        this.loading = false
        this.processMetadata(data.metadata)
      }).catch((e) => {
        this.$bvToast.toast("Load data failed, please reload the page.", {
        title: "Warning",
        variant: "danger",
        solid: true,
        });
        console.error(e);
        this.loading = false
      });
    },

    onPageChange(page) {
      this.currentPage = page;
      this.queryJobOrder();
    },

    openDetail(item) {
      this.promptDetail = true
      this.detailModal = item
    },
    // add spinner while loading on searching data process
    debounceSearch(event) {
      this.loading = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.loading = false;
        this.search = event.target.value;
      }, 600);
    },
    async approve() {
      if (!this.detailModal.id) {
        this.$bvToast.toast("joborder id not found", {
          title: "Warning",
          variant: "danger",
          solid: true,
        });
        return
      }
      await this.$store
        .dispatch("joborder/approveDirectSale", {
          id: this.detailModal.id,
        })
        .then(() => {
          this.$bvToast.toast("Successfully Accept Mama drum", {
            title: "Success",
            variant: "success",
            solid: true,
          });
          this.$router.push({ name: "view-direct-sales", params: {id:this.detailModal.id} });
        })
        .catch((err) => {
          console.error(err)
          this.$bvToast.toast("Process failed ", {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
        });
    },

     reject() {
      if (!this.detailModal.id) {
        this.$bvToast.toast("joborder id not found", {
          title: "Warning",
          variant: "danger",
          solid: true,
        });
        return
      }
      this.$store
        .dispatch("joborder/rejectDirectSale", {
          id: this.detailModal.id
        })
        .then((res) => {
          this.$bvToast.toast(res, {
            title: "Success",
            variant: "success",
            solid: true,
          });
          this.queryJobOrder()
        })
        .catch((err) => {
          this.$bvToast.toast(err, {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
        });
    },
  },
  computed: {
    jobOrders() {
      return this.$store.getters["joborder/getDirectSales"]
    },
    permission() {
      return userAccess("direct sales");
    }
  },
};
</script>

<style scoped>
.select-sm .vs__dropdown-toggle {
  min-height: 30px;
}

@media (min-width: 761px) {
  .show-on-mobile {
    display: none !important;
  }
}
@keyframes spinner {
  0% {
    transform: translate3d(-50%, -50%, 0) rotate(0deg);
  }
  100% {
    transform: translate3d(-50%, -50%, 0) rotate(360deg);
  }
}
.spin::before {
  animation: 1.5s linear infinite spinner;
  animation-play-state: inherit;
  border: solid 5px #cfd0d1;
  border-bottom-color: #0077b3;
  border-radius: 50%;
  content: "";
  height: 20px;
  width: 20px;
  position: absolute;
  margin-top: 20px;
  transform: translate3d(-50%, -50%, 0);
  will-change: transform;
}

.scrollable-table {
  overflow-x: auto;
  width: 100%;
}
</style>
